type TenantNotFoundViewProps = {
  hostname: string;
  landingUrl: string;
  appUrl: string;
};

export function TenantNotFoundView({ hostname, landingUrl, appUrl }: TenantNotFoundViewProps) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f3f3f4] px-6 py-10">
      <section className="w-full max-w-3xl overflow-hidden rounded-[36px] border border-white/80 bg-white shadow-[0_30px_90px_rgba(15,23,42,0.12)]">
        <div className="brand-primary-panel px-8 py-7">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-white/72">Workspace unavailable</p>
          <h1 className="font-headline mt-3 text-3xl font-extrabold tracking-[-0.04em] text-white sm:text-4xl">
            That workspace does not exist.
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-white/82 sm:text-base">
            The workspace at {hostname} could not be found. It may never have been created, or it may have been removed.
          </p>
        </div>

        <div className="space-y-6 px-6 py-6 sm:px-8 sm:py-8">
          <div className="rounded-[24px] border border-[#eaecf0] bg-[#f8fafc] px-5 py-5">
            <p className="text-sm leading-7 text-[#475467]">
              If you were invited to a workspace, confirm the subdomain with your team. If you are trying to create a new workspace,
              start from the main site and provision one first.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href={landingUrl}
              className="brand-primary-button inline-flex items-center justify-center rounded-[22px] px-5 py-3 text-sm font-bold uppercase tracking-[0.2em] no-underline transition-all"
            >
              Go to kuii.net
            </a>
            <a
              href={appUrl}
              className="brand-primary-subtle-button inline-flex items-center justify-center rounded-[22px] px-5 py-3 text-sm font-bold uppercase tracking-[0.2em] no-underline transition-all"
            >
              Open app hub
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}